import { RadioButtonOption } from "../../../common/enums";

export const ASBESTOS_CHECKLIST_VERSION_2026_02 = 1;

export type AsbestosChecklist = {
    checklistVersion: number | undefined;
    leaderAndPersonalHaveCorrectEducation: RadioButtonOption;
    isTotalTimeForSanitationMoreThanOneHour: RadioButtonOption;
    hasApprovalFromEnvironmentalAgency: RadioButtonOption;
    hasCorrectDocuments: RadioButtonOption;
    externalPersonalIsContracted: RadioButtonOption;
    isWholeMaskWithCompressedAirUsed: RadioButtonOption;
    areMasksFittedForRespPerson: RadioButtonOption;
    masksAreStoredAccordingAccordingToRules: RadioButtonOption;
    areOwnMachinesUsedForSanitation: RadioButtonOption;
    isSanitisedFromAsbestosDust: RadioButtonOption;
    hasSignForAsbestos: RadioButtonOption;
    hasApprovalForThisProject: RadioButtonOption;
};

